import React from 'react';

const IconDevpost = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 64 64"
    width="64"
    height="64">
    <title>Devpost</title>
    <g>
      <g>
        <path d="M48.7,4.8H15.3L0,32l15.7,27.2h33.1L64,32L48.7,4.8z" />
      </g>
      <path
        fill="var(--bg-color)"
        d="M32.2,16.9H21.4v30.3h10.8c8.2,0,14.9-6.8,14.9-15.1S40.5,16.9,32.2,16.9z M32,41.1h-4.5V22.9H32
          c5,0,9.1,4.1,9.1,9.1S37,41.1,32,41.1z"
      />
    </g>
  </svg>
);
export default IconDevpost;
